export const GRADES = ["A", "B", "C", "D"] as const;

export type Grade = (typeof GRADES)[number];

export const isGrade = (value: unknown): value is Grade => GRADES.some((grade) => grade === value);
